// eslint-disable-next-line import/no-cycle
import LoginForm from 'profile/login/forms/LoginFormNoRoutes';

const ReturningCustomer = (props) => {
  const { redirectLink, onForgotPassword, onMagicLink } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <LoginForm
        redirectLink={redirectLink}
        onForgotPassword={onForgotPassword}
        onMagicLink={onMagicLink}
      />
    </div>
  );
};

export default ReturningCustomer;
